module.exports = __webpack_public_path__ + "img/bg.435b7cdd.png";